module.exports = __webpack_public_path__ + "static/ptx_logo-52b392f0ff296f06ef67362cf57ccfa1.png";